export default "92c3dd9e7ad8cef7.svg"